// 「token 確定無效」的判斷，與 BDMS 認同一份。

// 後端回這幾個錯誤帶碼就是 token 確定無效。
// 逾時、500、網路斷線不算在內 —— 這些情況不知道 token 有沒有效。
export const TOKEN_INVALID_CODES = [1302, 1303, 1304, 1305, 1306]

// token 是否無效
export function isTokenInvalid (error) {
  const httpStatus = error.response && error.response.status
  const apiStatus = error.response && error.response.data && error.response.data.status
  return httpStatus === 401 || httpStatus === 403 || TOKEN_INVALID_CODES.includes(apiStatus)
}



// WEBPACK FOOTER //
// ./src/assets/js/token-error.js